import { Request } from "Utils/Request"
import { API_BASE_URL } from 'config.js';

const postCreditsReports = (params, onSuccess, onFail) => {
    return Request({url: API_BASE_URL+'credits/reports', method: 'post', params: params}, onSuccess, onFail);
}

export default {
    postCreditsReports
}